var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5112 32.2745H12.4918C2.14922 32.2745 0.443909 28.4271 0.443909 20.4002V12.1489C0.443909 3.7061 0.443907 0.274536 12.4918 0.274536H34.5082C46.1013 0.274536 46.5561 3.26332 46.5561 12.1489V20.4002C46.5591 30.0247 43.8515 32.2745 34.5112 32.2745Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7896 9.59387L31.2204 16.0501L18.7896 22.5453V9.59387Z",
    fill: "#090D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7005 16.8459L18.7896 9.59387L31.2204 16.0471L29.7005 16.8459Z",
    fill: "#0C111E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.65a1d02659fc2a94d9fa5642d166989f.svg";
export { ForwardRef as ReactComponent };